export function useImagesetRef(dataImage) {
    return {
        mobile: dataImage?.model?.data?.mobile?.links.site.href || '',
        tablet: dataImage?.model?.data?.tablet?.links.site.href || '',
        desktop: dataImage?.model?.data?.desktop?.links.site.href || '',
        original: dataImage?.model?.data?.original?.links.site.href || '',
    }
}
